/**
 * Bookmark folders API slice.
 * Leaf module (Perf 3.1.b/e Step 5). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const bookmarkFoldersApi = {
  fetchFolders: async () => {
    const data = await fetchWithAuth('/json/bookmark-folders');
    if (data.error) throw new ApiError(data.message || 'Failed to fetch folders', 400, data);
    return data.folders || [];
  },

  createFolder: async (name, icon, parentId) => {
    const body = { name, icon };
    if (parentId) body.parentId = parentId;
    const data = await fetchWithAuth('/json/bookmark-folders', {
      method: 'POST',
      body,
    });
    if (data.error) throw new ApiError(data.message || 'Failed to create folder', 400, data);
    return data.folder;
  },

  updateFolder: async (folderId, updates) => {
    const data = await fetchWithAuth(`/json/bookmark-folders/${folderId}`, {
      method: 'PUT',
      body: updates,
    });
    if (data.error) throw new ApiError(data.message || 'Failed to update folder', 400, data);
    return data.folder;
  },

  deleteFolder: async (folderId) => {
    const data = await fetchWithAuth(`/json/bookmark-folders/${folderId}`, {
      method: 'DELETE',
    });
    if (data.error) throw new ApiError(data.message || 'Failed to delete folder', 400, data);
    return data;
  },

  addItem: async (folderId, conversationId, messageId) => {
    const data = await fetchWithAuth(`/json/bookmark-folders/${folderId}/items`, {
      method: 'POST',
      body: { conversationId, messageId },
    });
    if (data.error) throw new ApiError(data.message || 'Failed to add to folder', 400, data);
    return data.folder;
  },

  removeItem: async (folderId, conversationId, messageId) => {
    const data = await fetchWithAuth(`/json/bookmark-folders/${folderId}/items`, {
      method: 'DELETE',
      body: { conversationId, messageId },
    });
    if (data.error) throw new ApiError(data.message || 'Failed to remove from folder', 400, data);
    return data.folder;
  },
};
